/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Mark_Paid_ButtonInputs */

const vi_order_mark_paid_button = /** @type {(inputs: Order_Mark_Paid_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh dấu đã thanh toán`)
};

/**

* @param {Order_Mark_Paid_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_mark_paid_button = /** @type {((inputs?: Order_Mark_Paid_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Mark_Paid_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_mark_paid_button(inputs)
});